
module.exports = function getResource(label, vars = []) {
    const resources = {
        shopFaves: 'Shop Your Favorites',
        fromLovesList: 'From your Loves list.'
    };
    return resources[label];
};
